exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles--routerTest--8Hr4WSku {\r\n\r\n}\r\n", ""]);

// exports
exports.locals = {
	"routerTest": "styles--routerTest--8Hr4WSku"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/views/RouterTest/styles.css
// module id = 890
// module chunks = 1